import React from 'react'

function FarmerDashboard() {
    return (
        <div>FarmerDashboard</div>
    )
}

export default FarmerDashboard